import React, { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import InquiryTicketMdl from "../InquiryTicketMdl";

const InquiryModal = ({
  isOpen,
  handleProductDtlMdl,
  inquiryData
}) => {

  const [isTicketInquiryMdl, setIsTicketInquiryMdl] = useState(false);
  const [productData, setProductData] = useState(null);

  const handleIsTicketInquiryMdl = () => {
    setIsTicketInquiryMdl(!isTicketInquiryMdl)
  }

  const handleTicketInquiry = (data) => {
    handleIsTicketInquiryMdl();
    setProductData(data.ITEM_CD);
  }

  return (
    <div>
      <Modal
        backdrop="static"
        keyboard={false}
        size="lg"
        show={isOpen}
        onHide={handleProductDtlMdl}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="fw-bold">
              {inquiryData.ITEM_NM}
              <div
                className="fw-normal text-primary text-xs"
              >
                {inquiryData.CAT_NM}
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <Row>
            {/* <Col md={12} className="d-flex mb-2 pb-2 border-bottom">

            </Col> */}
            <Col md={6}>
              <div className="text-sm" style={{ textAlign: "justify" }} dangerouslySetInnerHTML={{
                __html: inquiryData?.DESCRIPTIONS || inquiryData?.DESCRIPTION,
              }} />
            </Col>
            <Col md={6}>
              <div className="my-2">
                <img
                  src={inquiryData.IMG}
                  alt="product"
                  width="100%"
                  className="card"
                />
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button
            type="button"
            variant="primary"
            className="btn-sm"
            onClick={() => handleTicketInquiry(inquiryData)}
          >
            Inquiry
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="btn-sm"
            onClick={handleProductDtlMdl}
            data-dismiss="modal"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {isTicketInquiryMdl &&
        <InquiryTicketMdl
          isOpen={isTicketInquiryMdl}
          handleIsTicketInquiryMdl={handleIsTicketInquiryMdl}
          itemCodeData={productData}
          setItemCodeData={setProductData}
          inquiryData={inquiryData}
        />
      }
    </div >
  );
};

export default InquiryModal;
